"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirect = exports.redirectDependsOnUserType = exports.getSeo = exports.getAuthHeadersToken = void 0;
const effects_1 = require("redux-saga/effects");
const next12_app_controller_reducers_sagas_main_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer");
const next12_utils_request_1 = __importDefault(require("@gcloud-npm/next12.utils.request"));
const REDIRECT_PAGE_WHEN_LOGGED = `https://www.movistar.es/particulares/mimovistar/oferta-personalizada`;
const REDIRECT_PAGE_WHEN_LOGGED_WEBVIEW = `https://www.movistar.es/particulares/mimovistar_webview/oferta-personalizada`;
const filePath = "sagas/main.js";
const contextStore = (state) => state.main.context;
const getAuthHeadersToken = (build = true, system = "cms") => {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    let authorizationHeader = {};
    if (system === "cms") {
        if (currentEnv === "qa" && build) {
            authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CMS_TOKEN}`);
        }
    }
    if (system === "customizer") {
        if (currentEnv === "qa" && build) {
            authorizationHeader = JSON.parse(`${process.env.NEXT_PUBLIC_CUSTOMIZER_TOKEN}`);
        }
    }
    return authorizationHeader;
};
exports.getAuthHeadersToken = getAuthHeadersToken;
const fetchSEO = (seoReq) => __awaiter(void 0, void 0, void 0, function* () {
    let url = "https://customizer.col.movistar.es/api/seo/get";
    let headers = {
        "Content-Type": "application/json",
        Origin: "https://www.movistar.es",
    };
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (currentEnv === "qa") {
        url = "https://qa.customizer.col.movistar.es/api/seo/get";
        const authHeaders = (0, exports.getAuthHeadersToken)(true, "customizer");
        headers.Origin = "https://qa.cms.col.movistar.es";
        headers = Object.assign(Object.assign({}, headers), authHeaders);
    }
    const request = new next12_utils_request_1.default({
        method: "POST",
        endpoint: url,
        data: seoReq,
        headers,
    });
    const resp = request.makeRequest();
    return resp;
});
function* getSeo({ seoReqData }) {
    const context = yield (0, effects_1.select)(contextStore);
    try {
        const res = yield (0, effects_1.call)(fetchSEO, seoReqData, context);
        const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
        if (res && !res.errno) {
            yield (0, effects_1.put)(next12_app_controller_reducers_sagas_main_reducer_1.actions.setCurrentSeo(res));
        }
        if ((!res || res.errno) && currentEnv !== "dev") {
            throw new Error("No tenemos datos de seo");
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next12_app_controller_reducers_sagas_main_reducer_1.actions.throwSonda({
            processName: "getSeo",
            filePath,
            error,
            kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.ERROR,
        }));
        yield (0, effects_1.put)(next12_app_controller_reducers_sagas_main_reducer_1.actions.setCurrentSeo(null));
    }
}
exports.getSeo = getSeo;
function* redirectDependsOnUserType({ data }) {
    const context = yield (0, effects_1.select)(contextStore);
    try {
        if (data.eventInfo) {
            yield (0, effects_1.put)(next12_app_controller_reducers_sagas_main_reducer_1.actions.sendCmsEvent(data.eventInfo));
        }
        if (context &&
            context.userType !== "" &&
            typeof window !== "undefined" &&
            window.location.href.indexOf("allowVisit") === -1) {
            let destino = REDIRECT_PAGE_WHEN_LOGGED;
            if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
                destino = REDIRECT_PAGE_WHEN_LOGGED_WEBVIEW;
            }
            document.location.href = destino;
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next12_app_controller_reducers_sagas_main_reducer_1.actions.throwSonda({
            processName: "redirectDependsOnUserType",
            filePath,
            error,
            kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.ERROR,
        }));
    }
}
exports.redirectDependsOnUserType = redirectDependsOnUserType;
function* redirect({ data }) {
    const { url, eventInfo } = data;
    try {
        if (url && eventInfo) {
            yield (0, effects_1.put)(next12_app_controller_reducers_sagas_main_reducer_1.actions.sendCmsEvent(eventInfo, () => {
                document.location.href = url;
            }));
        }
        if (url && !eventInfo) {
            document.location.href = url;
        }
    }
    catch (error) {
        yield (0, effects_1.put)(next12_app_controller_reducers_sagas_main_reducer_1.actions.throwSonda({
            processName: "redirect",
            filePath,
            error,
            kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.ERROR,
        }));
    }
}
exports.redirect = redirect;
//# sourceMappingURL=index.js.map